import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResearchView from '../views/ResearchView.vue'
import CasesView from '../views/CasesView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    props: (route) => ({ lang: route.query.lang })
  },
  {
    path: '/research',
    name: 'research',
    component: ResearchView,
    props: (route) => ({ lang: route.query.lang })
  },
  {
    path: '/cases',
    name: 'cases',
    component: CasesView,
    props: (route) => ({ lang: route.query.lang })
  },
  // Partner 隱藏頁面
  {
    path: '/partner/:partnerId',
    name: 'partner',
    component: () => import('../views/partner/PartnerView.vue'),
    meta: { hideNav: true }
  },
  // Partner 沒有指定 partnerId 時導回首頁
  {
    path: '/partner',
    redirect: '/'
  },
  {
    path: '/partner/',
    redirect: '/'
  },
  // Product 影片頁面
  {
    path: '/product/:productId/:videoId',
    name: 'product-video',
    component: () => import('../views/product/VideoView.vue'),
    meta: { hideNav: true }
  },
  // Product 沒有完整路徑時導回首頁
  {
    path: '/product/:productId',
    redirect: '/'
  },
  {
    path: '/product/:productId/',
    redirect: '/'
  },
  {
    path: '/product',
    redirect: '/'
  },
  {
    path: '/product/',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',  // 使用 history 模式
  routes
})

export default router